module.exports = __webpack_public_path__ + "img/not-convex2.172aedd2.svg";